<template>
    <v-row>
      <v-col cols="12">
        <h3>{{ Translator('admin.notice_collection.facets.most_viewed') }}</h3>
        <ul>
          <li v-for="notice in notices" :key="notice.id">
            <a :href="notice.url">
              {{ notice.titles.title }} ({{ notice.views }})
            </a>
          </li>
        </ul>
      </v-col>
    </v-row>
</template>

<script>
import axios from 'axios'

export default {
  name: 'NoticeMostViews',
  data: () => ({
    notices: [],
    props: [
      'profiles',
      'profiles',
    ],
    loading: false
  }),
  mounted () {
    this.getNotices()
  },
  methods: {
    getNotices () {
      this.loading = true
      axios
          .get('/api/v2/notices', {
            params: {
              itemsPerPage: 5,
              'order[views]': 'desc',
              onlyWithViews: 'true',
            }
          })
          .then(response => {
            this.notices = response.data['hydra:member'].filter(notice => notice.views > 0)
          })
          .catch(error => {
            console.error(error)
            this.errored = true
          })
          .finally(() => this.loading = false)
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    }
  }
}
</script>
